import { AppLink } from 'apps/woundscantwait-com/src/libs/components/components';

const ApligrafSafetyInformation = () => {
  return (
    <div className="py-14 px-5">
      <div className="max-w-[1200px] mx-auto">
        <h4 className="text-[27px] text-[#707070]">
          Apligraf
          <span className="text-[16px] align-super">®</span> is a unique product
          for treating Diabetic Foot Ulcers (DFUs) and Venous Leg Ulcers (VLUs){' '}
        </h4>
        <h5 className="mt-6 text-[18px] font-bold font-benton-sans">
          APLIGRAF IMPORTANT SAFETY INFORMATION:{' '}
        </h5>
        <p className="mt-2 text-[18px]">
          Apligraf is FDA-approved for the treatment of venous leg ulcers and
          diabetic foot ulcers lasting longer than one month that have not
          adequately responded to conventional therapy. It contains living
          cells, proteins produced by the cells, and collagen. Complications may
          include suspected wound or non-wound infection, skin inflammation,
          wound drainage, swelling, a skin tear or cut, pain, a new ulcer, red,
          flaky skin, bone infection, rash, low or high blood sugar, bruising,
          swelling, worsening ulcer, and dry skin. Apligraf should not be used
          if your wound is infected or if you are allergic to cow collagen or
          the agarose shipping medium. For more information, please read the
          complete prescribing information available at{' '}
          <AppLink
            to="https://Apligraf.com"
            target="_blank"
            className="text-[#007297] no-underline fancy-underline"
          >
            Apligraf.com
          </AppLink>
        </p>
        <p className="text-[#707070] font-semibold text-[18px] leading-[22px] mt-6">
          This website is not intended to provide diagnosis, treatment, or
          medical advice. Products, services, information and other content
          provided on this website are provided for informational purposes only.
          Information on this website should not be considered as a substitute
          for advice from a healthcare professional. Consult with a physician or
          other healthcare professional regarding any medical or health-related
          diagnosis or treatment options.
        </p>
      </div>
    </div>
  );
};

export { ApligrafSafetyInformation };
